var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6663 38.6667L28.9997 29L19.333 38.6667",
    stroke: "#2A9D8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29V50.75",
    stroke: "#2A9D8F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2754 44.4424C51.6324 43.1574 53.4945 41.1241 54.5676 38.6633C55.6407 36.2025 55.8637 33.4544 55.2015 30.8528C54.5394 28.2511 53.0296 25.9441 50.9107 24.2957C48.7917 22.6474 46.1841 21.7517 43.4995 21.7499H40.4545C39.7231 18.9206 38.3597 16.2939 36.4669 14.0673C34.5741 11.8407 32.2012 10.0722 29.5266 8.89472C26.852 7.71722 23.9452 7.16137 21.0248 7.26897C18.1044 7.37657 15.2465 8.14481 12.6657 9.51595C10.085 10.8871 7.84866 12.8254 6.12487 15.1852C4.40109 17.5451 3.23471 20.265 2.71341 23.1405C2.19211 26.0159 2.32946 28.9722 3.11514 31.787C3.90081 34.6017 5.31437 37.2018 7.24954 39.3916",
    stroke: "#2A9D8F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6663 38.6667L28.9997 29L19.333 38.6667",
    stroke: "#2A9D8F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.85cd0950d1c8112ad572905cfbbe1e9f.svg";
export { ForwardRef as ReactComponent };